import AccordionItemSecondary from "../../common/accordion-item/accordion-item-secondary/accordion-item-secondary";
import Title from "../../common/title/title";
import "./self-employed-page-accordion-list.sass";

const SelfEmployedFormPageAccordionList = () => {
  return (
    <div className="self-employed-page-accordion-list">
      <Title>Частые вопросы</Title>

      <div className="self-employed-page-accordion-list__list">
        <AccordionItemSecondary title="Что значит СМЗ? Кто может стать СМЗ?">
          Самозанятые (СМЗ) – физические лица, в т.ч. зарегистрированные в качестве ИП, которые выполняют работы/оказывают услуги по гражданско-правовым договорам и получают за это вознаграждение. В соответствии с законодательством РФ (Федеральный закон от 27.11.2018 N 422-ФЗ) самозанятым может стать любой гражданин РФ, Армении, Беларуси, Казахстана, Кыргызстана, Украины по достижении 14 лет.
          <br />
          <br />
          Для СМЗ от 14 до 18 лет дополнительно нужно предоставлять .{" "}
          <a
            className="link"
            style={{ color: "#115EF3" }}
            href="https://docs.google.com/document/d/1RI_fE8F30EMzB-NmIyoDD5whJC2YM6kR/edit?usp=sharing&ouid=100734229335461143660&rtpof=true&sd=true"
          >
            разрешение на работу от родителей (законных представителей)
          </a>
          .
        </AccordionItemSecondary>

        <AccordionItemSecondary title="Какие налоги платят СМЗ с доходов от деятельности?">
          Налог на профессиональный доход (НПД) – это специальный налоговый режим для физических лиц (в т.ч. ИП), который применяется СМЗ при условии соблюдения ограничений, установленных законодательством РФ (например, нет работников по трудовым договорам, ограничение по суммам – не более 2,4 млн. руб. и т.д.).
        </AccordionItemSecondary>

        <AccordionItemSecondary title="Как считается НПД?">
          НПД – соответствующая налоговой ставке процентная доля налоговой базы с учетом уменьшения суммы налога на сумму налогового вычета.
          Налоговая база – доход СМЗ. Расходы не учитываются.
          Ставки налога:
          <br />
          <br />
          <ul>
            <li>4% - при оказании услуг физлицам;</li>
            <li>6% - при оказании услуг ИП и ЮЛ.</li>
          </ul>
          <br />
          <br />
         
        </AccordionItemSecondary>

        <AccordionItemSecondary title="Как оплатить налог?">
          Сумма налога исчисляется налоговым органом как соответствующая
          налоговой ставке процентная доля налоговой базы с учетом уменьшения
          соответствующей суммы налога на сумму налогового вычета.
          <br />
          <br />
          Не позднее 12-го числа месяца, следующего за истекшим налоговым
          периодом, налоговый орган уведомляет налогоплательщика о сумме налога
          через мобильное приложение "Мой налог".
          <br />
          <br />
          Не позднее 28-го числа месяца, следующего за истекшим налоговым
          периодом необходимо уплатить налог.
          <br />
          <br />
          Процесс оплаты занимает не более 5 минут. В приложении «Мой налог»
          есть отдельный раздел для оплаты, в котором в определенный день месяца
          рассчитывается налог за предыдущий месяц и появляется кнопка
          "Оплатить". Также можно привязать карту и подключить автоплатеж, и
          налог будет списываться автоматически.
          <br />
          <br />
          Для самозанятых налоговая делает налоговый вычет это сумма в 10 000
          руб., которая уменьшает налог. Пока действует вычет, самозанятые
          уплачивают налог в размере:
          <br />
          <br />
          <ul>
            <li>3% вместо 4% с сумм оплаты от физлиц;</li>
            <li>4% вместо 6% - с доходов от организаций и ИП</li>
          </ul>
        </AccordionItemSecondary>

        <AccordionItemSecondary title="Можно ли быть ИП и СМЗ одновременно?">
          Да, ИП может стать СМЗ. Но нельзя совмещать НПД с упрощенной системой налогообложения (УСН) и другими специальными налоговыми режимами (ПСН, ЕСХН, АУСН).

ИП после регистрации в качестве СМЗ должен в течение месяца подать уведомление о прекращении применения УСН/ЕСХН.
        </AccordionItemSecondary>

        <AccordionItemSecondary title="Оформление в системе самозанятости CREON">
          СМЗ в рамках гражданских правоотношений с CREON является независимым Исполнителем/Подрядчиком. Между СМЗ и CREON заключается договор гражданско-правового характера, а не трудовой договор, поэтому документы, предусмотренные ТК РФ не оформляются, режим работы не устанавливается, СМЗ может заключать любые договоры с любыми третьими лицами.
        </AccordionItemSecondary>

        <AccordionItemSecondary title="Как зарегистрировать самозанятость через Мой налог?">
          ЧЕРЕЗ ЛИЧНЫЙ КАБИНЕТ НАЛОГОПЛАТЕЛЬЩИКА-ФИЗИЧЕСКОГО ЛИЦА:
          <br />
          <br />
          Нужен ИНН и пароль для доступа в Личный кабинет
          налогоплательщика-физического лица.
          <br />
          <br />
          <ul>
            <li>
              Укажите номер телефона: Указывайте тот номер, которым пользуетесь,
              и имеете доступ к которому привязан личный кабинет на Госуслугах.
              Когда придет код по СМС, введите его для подтверждения номера.
            </li>
            <li>
              Выберите регион: Укажите регион, в котором ведете деятельность.
            </li>
            <li>
              Введите данные для доступа: Укажите свой ИНН и тот пароль, который
              используете для доступа в Личный кабинет
              налогоплательщика-физического лица.
            </li>
            <li>
              Придумайте пин-код: Защитите приложение пин-кодом. Потом также
              можно настроить доступ по отпечатку пальца или Face ID, это
              зависит от функции телефона.
            </li>
          </ul>
          <br />
          <br />
          ЧЕРЕЗ ПОРТАЛ ГОСУДАРСТВЕННЫХ УСЛУГ:
          <br />
          <br />
          Нужен номер мобильного телефона или почта, ваш СНИЛС и пароль для
          доступа к личному кабинету портала государственных услуг.
          <br />
          <br />
          <ul>
            <li>Выберите способ регистрации.</li>
            <li>Введите логин и пароль от портала Госуслуг.</li>
          </ul>
          <br />
          <br />
          ПО ПАСПОРТУ:
          <br />
          <br />
          Достаточно наличие паспорта. На телефоне или планшете должна работать
          камера, вам нужно будет отсканировать её с помощью фотографии и
          сделать селфи.
          <br />
          <br />
          <ul>
            <li>
              Укажите номер телефона: Вам придет код по СМС. Он понадобится для
              подтверждения номера. Такая проверка защищает от регистрации без
              вашего ведома.
            </li>
            <li>
              Выберите регион: Укажите регион ведения деятельности. Он может не
              совпадать с местом регистрации по месту жительства.
            </li>
            <li>
              Отсканируйте паспорт: Поднесите его к камере телефона и разверните
              страницу. Программа распознает данные для заполнения заявки.
            </li>
            <li>
              Проверьте данные: Если данные заполняются некорректно,
              отсканируйте паспорт заново. Или отредактируйте информацию
              вручную.
            </li>
            <li>
              Сфотографируйтесь: Фотографию нужно сделать на камеру телефона, с
              которой регистрируетесь. Приложение сравнит ваше фото с фото в
              паспорте.
            </li>
            <li>
              Подтвердите регистрацию: Ваша заявка для регистрации будет
              отправлена в налоговый орган. Регистрация может пройти сразу или в
              течение нескольких дней.
            </li>
          </ul>
        </AccordionItemSecondary>

        <AccordionItemSecondary title="Как подписать договор с CREON?">
          Для того, чтобы наше сотрудничество имело юридическую силу необходимо
          подписать соглашение об использовании простой электронной подписи и
          договор.
          <br />
          <br />
          Для этого нужно:
          <br />
          <br />
          <ol>
            <li>Зарегистрироваться на сайте, заполнив форму заявки ниже</li>
            <li>
              Дождаться письма с Соглашением (обычно это происходит в день
              регистрации на сайте)
            </li>
            <li>
              Открыть письмо и подписать Соглашение с помощью четырехзначного
              кода из следующего письма
            </li>
            <li>
              Дождаться письма с Договором (приходит сразу после подписания
              Соглашения)
            </li>
            <li>
              Открыть письмо и подписать Договор с помощью четырехзначного кода
              из следующего письма
            </li>
          </ol>
        </AccordionItemSecondary>

        <AccordionItemSecondary title="Как производится оплата? Сколько ждать?">
          Оплата производится по личным банковским реквизитам СМЗ, которые указаны при регистрации на сайте CREON (для этого подойдет любая дебетовая карта любого банка, оформленная на ФИО СМЗ).
          <br />
          
          <br />
          Денежные средства, как правило, поступают на карту в этот же день, но
          срок поступления также зависит от банка получателя.
          <br />
          <br />
          Если нужно изменить реквизиты напиши письмо на почту{" "}
          <a
            className="link"
            style={{ color: "#115EF3" }}
            href="mailto:check@creon-btl.ru"
          >
            check@creon-btl.ru
          </a>{" "}
          с темой «Смена реквизитов» и укажи актуальные данные.
        </AccordionItemSecondary>

        <AccordionItemSecondary title="Что такое автопробитие чека? Можно ли его не подключать?">
          После оказания услуг/выполнения работ придет письмо с инструкцией подключения автопробития чека через сервис «Точка самозанятые» в Мой налог. 
          Самозанятые в Мой налог это единоразовая процедура.
          <br />
          <br />
          Приглашение на автопробитие придет в раздел Уведомления. Если
          приглашение не пришло напиши нам на почту и попроси отправить
          повторно.
          <br />
          <br />
          ВАЖНО: никаких приложений кроме Мой налог скачивать НЕ НУЖНО!
          <br />
          <br />
          Функция автопробития чека обязательна.
        </AccordionItemSecondary>

        <AccordionItemSecondary title="Как подключить автопробитие чека?">
          <ol>
            <li>
              Мой налог – Прочее: Открываем приложение "Мой налог", переходим в
              раздел "Прочее" (справа внизу).
            </li>
            <li>
              Партнеры - Точка Самозанятые: Переходим в раздел Партнеры,
              выбираем "Точка Самозанятые", нажимаем подключить.
            </li>
          </ol>
        </AccordionItemSecondary>

        <AccordionItemSecondary title="Как правильно написать согласие от родителей?">
          Несовершеннолетние самозанятые должны предоставить разрешение от
          родителей (законных представителей) на осуществление деятельности
          несовершеннолетним. Посмотреть пример согласия можно{" "}
          <a
            className="link"
            style={{ color: "#115EF3" }}
            href="https://docs.google.com/document/d/1RI_fE8F30EMzB-NmIyoDD5whJC2YM6kR/edit?usp=sharing&ouid=100734229335461143660&rtpof=true&sd=true"
          >
            здесь
          </a>
          .
        </AccordionItemSecondary>
      </div>
    </div>
  );
};

export default SelfEmployedFormPageAccordionList;
